(function() {

  // Fix carrinho mobile
  var _set = Object.getOwnPropertyDescriptor(CSSStyleDeclaration.prototype, 'paddingRight') ||
             Object.getOwnPropertyDescriptor(CSSStyleDeclaration.prototype, 'padding-right');

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-scroll-lock-scrollable]').forEach(function(el) {
      el.setAttribute('data-scroll-lock-scrollable', '');
    });
  });

  document.body.addEventListener('DOMSubtreeModified', function() {
    if (window.innerWidth <= 768) {
      document.body.style.cssText = document.body.style.cssText.replace(/padding-right:[^;]+;?/g, 'padding-right: 0px !important;');
    }
  });
  // Quantity buttons no carrinho
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
  if (!btn) return;
  
  var id = btn.getAttribute('data-id');
  var input = document.querySelector('.cart__qty-input[data-id="' + id + '"]');
  if (!input) return;
  
  var qty = parseInt(input.value) || 1;
  
  if (btn.hasAttribute('data-qty-minus')) {
    if (qty <= 1) return;
    qty--;
  } else {
    qty++;
  }
  
  input.value = qty;
  input.dispatchEvent(new CustomEvent('theme:cart:update', {
    bubbles: true,
    detail: { id: id, quantity: qty }
  }));
});
})();

// Total dentro do botao de checkout - modelo moderatrencin.com - 09/09/2026
(function(){function S(){var q=document.querySelectorAll('.cart__total__price--animated'),p=q[q.length-1];if(!p)return;var v=p.textContent.replace(/EUR/i,'').trim();if(!v)return;document.querySelectorAll('.cart__checkout[name="checkout"]').forEach(function(b){var d=b.getAttribute('data-lbl')||b.textContent.split('•')[0].trim();b.setAttribute('data-lbl',d);var t=d+' • '+v;if(b.textContent.trim()!=t)b.textContent=t;});}var m;function Q(){clearTimeout(m);m=setTimeout(S,80);}new MutationObserver(Q).observe(document.documentElement,{childList:true,subtree:true,characterData:true});document.addEventListener('DOMContentLoaded',Q);Q();})();